const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

const generateRandomString = (length = 30) => {
  return Math.random().toString(36).substring(2, length/2)
    + Math.random().toString(36).substring(2, length/2)
    + Math.random().toString(36).substring(2, length/2);
}

export {
  capitalize,
  generateRandomString
}
